import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import * as QueryRepository from "@/components/features/settings/payment-deposit-account/repository/query";

import { SettingsPaymentDepositAccountPresenter } from "./presenter";

type Props = {
	hotelID: string;
};

export const SettingsPaymentDepositAccountContainer = ({ hotelID }: Props) => {
	const { paymentDepositAccount } = QueryRepository.usePaymentDepositAccountQuery(hotelID);

	if (!paymentDepositAccount) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <SettingsPaymentDepositAccountPresenter serverModel={paymentDepositAccount} />;
};

SettingsPaymentDepositAccountContainer.displayName = "SettingsPaymentDepositAccountContainer";
